import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import ChannelFactory from './ChannelFactory.vue';
import ChannelNewFlowLayout from './ChannelNewFlowLayout.vue';
import ChannelsNewRouterOutlet from './ChannelsNewRouterOutlet.vue';

import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';
import InboxHome from './Index.vue';
import Settings from './Settings.vue';
import ChannelList from './ChannelList.vue';
import FinishSetup from './FinishSetup.vue';

const inboxDetailProps = () => ({
  headerTitle: '',
  showBackButton: false,
});

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      redirect: to => ({
        path: frontendURL(
          `accounts/${to.params.accountId}/settings/channels/list`
        ),
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/inboxes/:pathMatch(.*)*'),
      redirect: to => {
        const raw = to.params.pathMatch;
        const empty =
          raw === undefined ||
          raw === null ||
          raw === '' ||
          (Array.isArray(raw) && raw.length === 0);
        let suffix = 'list';
        if (!empty) {
          suffix = Array.isArray(raw) ? raw.filter(Boolean).join('/') : raw;
        }
        return {
          path: frontendURL(
            `accounts/${to.params.accountId}/settings/channels/${suffix}`
          ),
        };
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/channels'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_inbox_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_inbox_list',
          component: InboxHome,
          meta: {
            featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
            permissions: ['administrator'],
          },
        },
        {
          path: 'new',
          component: ChannelsNewRouterOutlet,
          children: [
            {
              path: '',
              name: 'settings_inbox_new',
              component: ChannelList,
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator'],
              },
            },
            {
              path: ':inbox_id/finish',
              component: ChannelNewFlowLayout,
              meta: {
                hideSettingsInnerNav: true,
                flushSettingsContent: true,
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator'],
              },
              children: [
                {
                  path: '',
                  name: 'settings_inbox_finish',
                  component: FinishSetup,
                  meta: {
                    featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                    permissions: ['administrator'],
                  },
                },
              ],
            },
            {
              path: ':inbox_id/agents',
              redirect: to => ({
                name: 'settings_inbox_finish',
                params: {
                  accountId: to.params.accountId,
                  inbox_id: to.params.inbox_id,
                },
              }),
            },
            {
              path: ':sub_page',
              component: ChannelNewFlowLayout,
              meta: {
                hideSettingsInnerNav: true,
                flushSettingsContent: true,
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator'],
              },
              children: [
                {
                  path: '',
                  name: 'settings_inboxes_page_channel',
                  component: ChannelFactory,
                  meta: {
                    featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                    permissions: ['administrator'],
                  },
                  props: route => ({
                    channelName: route.params.sub_page,
                  }),
                },
              ],
            },
          ],
        },
        {
          path: ':inboxId',
          component: SettingsContent,
          meta: {
            hideSettingsInnerNav: true,
            flushSettingsContent: true,
          },
          props: inboxDetailProps,
          children: [
            {
              path: ':tab?',
              name: 'settings_inbox_show',
              component: Settings,
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator'],
              },
            },
          ],
        },
      ],
    },
  ],
};
